module.exports = __webpack_public_path__ + "img/zhifubao.daed6e80.svg";